import React from 'react';
import { useUser } from '@/queries/useUser';
import { PaymentMethodsSection } from './store/PaymentMethodsSection';
import { LocalizationSection } from './store/LocalizationSection';
import { MarketingConsentSection } from './store/MarketingConsentSection';
import { TermsAndConditionsSection } from './store/TermsAndConditionsSection';
import { TaxDocumentsSection } from './store/TaxDocumentsSection';
import { TaxSection } from './store/TaxSection';
import { SUBSCRIPTION_TIERS } from '@/lib/api/subscriptions/types';
import { StanCard } from '@/components';

export const StoreTab: React.FC = () => {
    const { user } = useUser();

    const isAffiliateOnlySubscription = user?.subscription_tier === SUBSCRIPTION_TIERS.AFFILIATE;

    return (
        <StanCard>
            {/* Order: Payment Methods → Tax Documents → Currency → Marketing Consent → Terms & Conditions → Tax Section → Localization */}
            <div className='w-full space-y-8'>
                <PaymentMethodsSection isAffiliateOnly={isAffiliateOnlySubscription} />

                <TaxDocumentsSection />

                {!isAffiliateOnlySubscription && <MarketingConsentSection />}

                {!isAffiliateOnlySubscription && <TermsAndConditionsSection />}

                {!isAffiliateOnlySubscription && <TaxSection />}

                <LocalizationSection />
            </div>
        </StanCard>
    );
};

export default StoreTab;
